var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { AuthBaseComponent } from '../auth-base/auth-base.component';
import { AuthenticationStatus } from '../enums/enums';
var AuthAuthenticateMethodComponent = /** @class */ (function (_super) {
    __extends(AuthAuthenticateMethodComponent, _super);
    function AuthAuthenticateMethodComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loginOriginAction = "";
        _this.methodValueText = "";
        return _this;
    }
    AuthAuthenticateMethodComponent.prototype.ngOnInit = function () {
        this.authUserService.sendAuthData("ElasticLogger", { elasticCode: '2150' })
            .subscribe(function (res) { return console.log("sent elasticLog code:2150 - open window", res); }, function (error) { return console.log("sent elasticLog - open window error!", error); });
        sessionStorage.setItem("currentWindow", "בחירת אופן זיהוי אישי");
        sessionStorage.setItem("elasticCode", "2190");
        this.loginOriginAction = sessionStorage.getItem("loginOriginAction");
        this.isShowContactLink = this.shouldContactLink('authMethod');
    };
    AuthAuthenticateMethodComponent.prototype.submit = function (form) {
        var _this = this;
        var element = this.inputsQuery.map(function (elm) { return elm.elementRef.nativeElement; }).find(function (elm) { return elm.classList.contains('ng-invalid'); });
        if (element) {
            element.setAttribute('aria-invalid', true);
            setTimeout(function () { return element.focus(); }, 0);
        }
        if (form.valid) {
            this.pending = true;
            this.serverError = null;
            if (form.value == 1)
                this.methodValueText = "ID issue date";
            else
                this.methodValueText = "credit card";
            //console.log("parametes", form.value);
            this.authUserService.sendAuthData("StrictIdentification", form.value)
                .subscribe(function (res) {
                if (res.Status == AuthenticationStatus.Success) {
                    _this.modalService.close(res.Details);
                }
                else {
                    _this.serverError = res.Details;
                    //console.log("Failure", res.Details);
                }
            }, function () { return _this.pending = false; }, function () { return _this.pending = false; });
        }
        this.buildFormAccessibility();
    };
    return AuthAuthenticateMethodComponent;
}(AuthBaseComponent));
export { AuthAuthenticateMethodComponent };
